"use strict";var call=Function.prototype.call,$hasOwn=Object.prototype.hasOwnProperty,bind=require("function-bind");module.exports=bind.call(call,$hasOwn);